module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-16-a1090fec750abd1dd5d211761da64164.jpeg";